import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../../../environments/environment';
import { LoggingService } from '../../../services/logging.service';

const apiServer = environment.apiServer;

@Injectable()
export class NavbarInfoService {

  constructor(
    private client: HttpClient,
    private loggingService: LoggingService
  ) { }

  public get(): Observable<any> {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.NavbarInfoService.get';
    
    this.loggingService.logStart(xid, qualName, null, 'Getting person info');
    
    return this.client.get(`${apiServer}/persone`)
      .do(result => {
        this.loggingService.logFinish(xid, qualName, null, 'Person info retrieved');
      })
      .catch(error => {
        this.loggingService.logError(xid, qualName, error, null, 'Failed to get person info');
        return Observable.throw(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/services/navbar-info.service.ts